<script>
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';

  let {
    headingText = undefined,
    headingLevel = 'h2',
    content = undefined,
    noBottomMargin = false,
    dataTestId = 'page-note',
  } = $props();
</script>

<section
  data-testid={dataTestId}
  class="page-note p-4 md:max-w-136 md:my-22 md:py-7 md:px-12 md:mx-auto md:rounded-2xl md:shadow-y-lg"
  class:md:mb-0={noBottomMargin}
  class:md:mt-8={noBottomMargin}
>
  <BaseHeading {headingLevel} className="text-md md:text-lg text-black font-semibold leading-loose"
    >{headingText}</BaseHeading
  >
  <div class="markdown-wrapper">
    {@html content}
  </div>
</section>
